import OptionsAccessManager from "../../../../../gd/manager/options-access-manager";
import FieldUser, {ADD_USER} from "../../../../generic/user/user";
import FieldConfig from "../../../../proto/field-config";
import Task from "../../../../../model2/task/task";
import ItemModel from "../../../../../model2/item/item-model";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";



export default class FieldTaskActionRequiredUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Task Action Required User";
        this.noValueOptionLabel = 'No action required';

        this.placeholder        = "No Action Required"

        this.classes.PopoverMenuScrollContainer    = 'min-w-250 max-h-300'
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeActionRequired
    }

    access(model:any): 'read' | 'write' | false {

        if (_.has(model,'systemStatus')) {
            if (!gd.const.systemStatus.isOpen(model.systemStatus)) return 'read'
        }

        if (_.has(model,'projectId')) {
            // ARE you sure about it ? seems like not a good deal - check canChangeAr - this is task model
            if (!gd.ac.check.project.fullAccess(model.projectId)) return 'read'
        }

        return 'write'
    }

    getOptionsForEdit(model:Task) {

        // model = Task
        const projectId     = model.projectId
        const taskTypeId    = model.taskTypeId

        if (!projectId || !taskTypeId) {
            console.log("FieldTaskActionRequired #ERROR-FIELD-TASK-ACTION-REQUIRED-USER-45 no model passed")
            return []
        }

        const projectUsers = gd.session.projectUsers.filterByProject(projectId, gd.const.project.access.LIMITED)

        const arUserOptions = _(projectUsers.models)
            .filter((pu)=>{
                const companyUser = gd.session.companyUsers.getByUserId(pu.user.id)
                return companyUser && companyUser.companyRole !== gd.const.companyRole.CLIENT
            }) // filter out client users
            .value()

        this.noValueOption = OptionsAccessManager.allowNoActionRequiredUserOption(taskTypeId);

        const options : Option[] = _.map(arUserOptions, projectUser=>{
            return {
                value: projectUser.user.id,
                label: projectUser.user.name
            }
        })

        // there can be no acl in model (for example RequestForm model)
        if (model.acl?.canAddProjectUser) {
            options.push({
                value   : ADD_USER,
                label   : 'Add User',
                icon    : 'i5-plus'
            })
        }

        return options



    }


    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {

        // Special case whn add a user
        if (value === ADD_USER) {
            item.task.addUserAsActionsRequired()
            return
        }


        item.task.actionRequiredUserId = value
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // Schedule depend on AR
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }

}
